/**
 * TypeBox schemas for Trip and TripMember entities
 */

import { Type, type Static } from 'typebox'
import { UUID, ISODate, Bounds, type Exact } from './common.js'

// --- Trip ---

export const DateRangeSchema = Type.Object({
  startDate: ISODate,
  endDate: ISODate,
})

export const DifficultySchema = Type.Union([
  Type.Literal('beginner'),
  Type.Literal('intermediate'),
  Type.Literal('advanced'),
  Type.Literal('expert'),
])

export const TripStatusSchema = Type.Union([
  Type.Literal('planning'),
  Type.Literal('upcoming'),
  Type.Literal('active'),
  Type.Literal('completed'),
  Type.Literal('cancelled'),
])

export const TripSchema = Type.Object({
  id: UUID,
  name: Type.String({ minLength: 1, maxLength: 100 }),
  description: Type.String({ minLength: 1, maxLength: 1000 }),
  dateRange: DateRangeSchema,
  location: Type.String({ minLength: 1, maxLength: 200 }),
  difficulty: DifficultySchema,
  status: TripStatusSchema,
  createdBy: UUID,
  teamLeader: UUID,
  createdAt: ISODate,
  updatedAt: ISODate,
  bounds: Type.Optional(Bounds),
  featureIds: Type.Optional(Type.Array(UUID)),
  trackIds: Type.Optional(Type.Array(UUID)),
})
export type Trip = Exact<Static<typeof TripSchema>>

/** Fields required when creating a trip */
export const TripCreateSchema = Type.Object({
  name: Type.String({ minLength: 1, maxLength: 100 }),
  description: Type.String({ minLength: 1, maxLength: 1000 }),
  dateRange: DateRangeSchema,
  location: Type.String({ minLength: 1, maxLength: 200 }),
  difficulty: DifficultySchema,
  createdBy: UUID,
  teamLeader: UUID,
})

/** Partial trip for updates */
export const TripUpdateSchema = Type.Partial(TripSchema)

// --- TripMember ---

export const TripMemberSchema = Type.Object({
  tripId: UUID,
  userId: UUID,
  role: Type.Union([Type.Literal('leader'), Type.Literal('member'), Type.Literal('viewer')]),
  status: Type.Union([
    Type.Literal('invited'),
    Type.Literal('confirmed'),
    Type.Literal('declined'),
  ]),
  joinedAt: ISODate,
})
export type TripMember = Static<typeof TripMemberSchema>
